import { operarPath } from './operar/operate-types';

/**
 * The default way INTO an existing disruption from anywhere it is LISTED —
 * dashboard panel, situation board, search, notifications, flight chips, the
 * declare results: «Operar la disrupción» (PO, 2026-10-26 — Express and the
 * Tower stay as they are while it is tried; the situation board keeps a «Torre»
 * link per row). The ONE place that decides it: `state` is for a board that takes
 * one (Express landed PAUSED — entering to look must not start firing steps). A
 * FRESH declare lands where «Abrir en» says — «Operar» by default (`landingOf` in
 * lib/declare).
 */
export function disruptionEntry(urn: string): { to: string; state?: { autopilot: 'paused' } } {
  return { to: operarPath(urn) };
}
